import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(4),
  },
  alert: { marginBottom: theme.spacing(4), maxWidth: 'none' },
  alertBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    backgroundColor: '#F9F9F9',
  },
  body: {
    marginBottom: theme.spacing(1),
  },
  bodyGrey: {
    marginBottom: theme.spacing(1),
    color: '#666666',
  },
  additionalHelp: {
    marginTop: theme.spacing(2),
  },
  emptyDeliveryDate: {
    marginBottom: theme.spacing(4),
    color: '#865000',
    backgroundColor: '#FFFBCC',
    maxWidth: 'none',
  },
  additionalHelpList: {
    listStyleType: 'disc',
    paddingLeft: theme.spacing(2),
    '& .MuiListItem-root': {
      display: 'list-item',
      color: 'inherit',
    },
  },
  iconContainer: {
    marginRight: '17px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
  },
}))

export default useStyles
